import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CoreButtonStyle } from '../core-button/core-button.component';
/*
  Generated class for the coreAlert page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
    selector: 'core-alert',
    templateUrl: './core-alert.component.html',
    styleUrls: [ './core-alert.component.scss' ],
})
export class CoreAlertPage
{

    //#region Class Constructor

    /**
     * Class constructor
     * NOTE: paramters are automaticly bound to matching named property (buttons, message, title)
     */
    constructor(private modalCtrl: ModalController)
    {

    }

    //#endregion


    //#region Properties

    /**
     * List of buttons to show in the dialog
     */
    public buttons: CoreDialogButton[];

    /**
     * Text to show in the dialog
     */
    public message: string;

    /**
     * Title to show in the dialog
     */
    public title: string;

    //#endregion


    //#region Methods

    /**
     * IonicUpdate handle dismiss view
     * Handle the button tapped event
     * @param button 
     */
    public handleButtonTapped(button: CoreDialogButton)
    {
        // if a button tapped action was specifeid, execute it
        if (button.action)
        {
            button.action();
        }

        // dismiss the dialog
        this.modalCtrl.dismiss();
    }

    //#endregion

}

/**
 * Interface describing the configuration of a button
 */
export interface CoreDialogButton
{
    /**
     * Text to show in the button
     */
    text: string;

    /**
     * Boolean flag indicating whether the button will be solid or outline
     */
    solid: boolean;

    /**
     * Action to perform when the button is clicked
     */
    action?: () => void
}

/**
 * Interface describing the conguration of a dialog
 */
export interface CoreDialogOptions
{
    /**
     * Title to show in the dialog
     */
    title: string;

    /**
     * Message to show in the dialog
     */
    message: string;

    /**
     * Buttons to show in the dialog
     */
    buttons: CoreDialogButton[];
}
